<script lang="ts" setup>
import { type PropType } from 'vue';
import { FormElement } from '@common';

const props = defineProps({
  element: {
    type: Object as PropType<FormElement>,
    required: true
  }
});

const orderDates = props.element.value ?? [];
</script>

<template>
  <div class="d-flex flex-wrap ga-1">
    <template v-if="orderDates.length">
      <v-chip
        v-for="(orderDate, index) in orderDates"
        :key="index"
        color="grey-lighten-3"
        variant="flat">
        {{ orderDate }}
      </v-chip>
    </template>
    <span v-else>-</span>
  </div>
</template>
